// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__TBU4o","icon":"SortAdornment_icon__3B994","up":"SortAdornment_up__3EjlJ","down":"SortAdornment_down__W2UQw","active":"SortAdornment_active__3qAZo"};